<template src="./SideMenuItem.html"></template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import AppIcon from "../AppIcon";
import type { MenuItem } from "../SideMenu/SideMenu.vue";

export default defineComponent({
    components: { AppIcon },
    props: {
        item: { type: Object as PropType<MenuItem>, required: true }
    },
    emits: [],
    computed: {
        isActive(): boolean {
            if (!this.item.to) return false;
            const path = this.$route.fullPath;
            return (
                (this.item.exact && path === this.item.to) ||
                (!this.item.exact && path.startsWith(this.item.to))
            );
        }
    },
    methods: {
        async navigate(): Promise<void> {
            if (this.item.to) {
                if (this.$route.path === this.item.to) return;

                await this.$router.push(this.item.to);
            }

            if (this.item.onClick) await this.item.onClick();
        }
    },
    data() {
        return {
            clickEventString: "click" as const
        };
    }
});
</script>

<style src="./SideMenuItem.scss" lang="scss" scoped></style>
